var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupabase = function SvgSupabase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#supabase_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F2ED",
    d: "M12.918.859h-8.5a3.75 3.75 0 0 0-3.75 3.75v8.5a3.75 3.75 0 0 0 3.75 3.75h8.5a3.75 3.75 0 0 0 3.75-3.75v-8.5a3.75 3.75 0 0 0-3.75-3.75"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "supabase_svg__b",
    width: 13,
    height: 14,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.725 2.609H2.668v12.5h12.057z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#supabase_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#supabase_svg__c)",
    d: "M9.715 14.808a.541.541 0 0 1-.965-.329L8.638 7.04h5.003c.906 0 1.411 1.047.848 1.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#supabase_svg__d)",
    fillOpacity: 0.2,
    d: "M9.715 14.808a.541.541 0 0 1-.965-.329L8.638 7.04h5.003c.906 0 1.411 1.047.848 1.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3ECF8E",
    d: "M7.68 2.838a.541.541 0 0 1 .966.328l.049 7.44h-4.94a1.083 1.083 0 0 1-.848-1.757z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "supabase_svg__c",
    x1: 8.638,
    x2: 13.084,
    y1: 8.69,
    y2: 10.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#249361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "supabase_svg__d",
    x1: 6.667,
    x2: 8.695,
    y1: 5.991,
    y2: 9.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "supabase_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.668.859h16v16h-16z"
  })))));
};
export default SvgSupabase;